import { useMemo } from 'react';

import { Job } from 'src/types/gojob';

const mapDayToNumber = (day?: Required<Job>['timeTables'][0]['day']) => {
  switch (day) {
    case 'MONDAY':
      return 1;
    case 'TUESDAY':
      return 2;
    case 'WEDNESDAY':
      return 3;
    case 'THURSDAY':
      return 4;
    case 'FRIDAY':
      return 5;
    case 'SATURDAY':
      return 6;
    case 'SUNDAY':
      return 7;
    default:
      return undefined;
  }
};

const useTimeTables = (job?: Job) => {
  return useMemo(() => {
    const timeTables = job?.timeTables || [];
    return timeTables.map((timeTable) => {
      return { ...timeTable, day: mapDayToNumber(timeTable?.day) };
    });
  }, [job]);
};

export default useTimeTables;
